export default "__VITE_ASSET__CeZlUl25__"